export const tagChange = 'CHANGE_TAG';
export const addNestedTypeA = 'ADD_NESTED_TYPE_A';
export const addNestedTypeAInnerArray = 'ADD_NESTED_TYPE_A_INNER_ARRAY';
export const updateNestedTypeAValue = 'UPDATE_NESTED_TYPE_A_VALUE';
export const removeNestedTypeA = 'REMOVE_NESTED_TYPE_A';
export const removeNestedTypeAInnerArray = 'REMOVE_NESTED_TYPE_A_INNER_ARRAY';
export const richTextEditorChange = 'RICH_TEXT_EDITOR_KEY_CHANGE';
export const richTextEditorSave = 'RICH_TEXT_EDITOR_SAVE';
export const richTextEditorDiscard = 'RICH_TEXT_EDITOR_DISCARD';
export const embeddedTypeValueUpdate = 'EMBEDDED_TYPE_VALUE_UPDATE';